module.exports = __webpack_public_path__ + "static/media/poster.f1ecdc2f.png";